import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,_vm._b({attrs:{"items":_vm.itens,"item-value":"value","item-text":"text","outlined":"","dense":"","hide-details":""},model:{value:(_vm.valor_computed),callback:function ($$v) {_vm.valor_computed=$$v},expression:"valor_computed"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }